import axios from 'axios';

const LOCAL_API_BASE_URL = 'http://localhost:8080/api';
const PRODUCTION_API_BASE_URL = 'https://api.abastecemaisapp.com.br/api';

const currentHostname = window.location.hostname;

const isLocalRuntime =
  process.env.NODE_ENV === 'development' ||
  currentHostname === 'localhost' ||
  currentHostname === '127.0.0.1' ||
  currentHostname === '::1' ||
  currentHostname.startsWith('192.168.') ||
  currentHostname.startsWith('10.') ||
  /^172\.(1[6-9]|2\d|3[0-1])\./.test(currentHostname);

const API_BASE_URL =
  isLocalRuntime
    ? LOCAL_API_BASE_URL
    : process.env.REACT_APP_API_URL || PRODUCTION_API_BASE_URL;

// Rotas públicas que não devem redirecionar para login em caso de 401
const PUBLIC_ROUTES = ['/login', '/cadastro-parceiro', '/politica-privacidade', '/suporte'];

// Endpoints que não devem causar redirecionamento automático em caso de 401
// (o AuthContext cuida desses endpoints)
const SKIP_REDIRECT_ENDPOINTS = ['/auth/me', '/auth/login'];

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token JWT em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Verificar se a rota atual é pública
      const currentPath = window.location.pathname;
      const isPublicRoute = PUBLIC_ROUTES.some(route => currentPath.startsWith(route));

      // Verificar se o endpoint chamado está na lista de skip
      const requestUrl = error.config?.url || '';
      const isSkipRedirectEndpoint = SKIP_REDIRECT_ENDPOINTS.some(endpoint => requestUrl.includes(endpoint));

      // Só redireciona para login se NÃO estiver em rota pública e NÃO for endpoint de skip
      if (!isPublicRoute && !isSkipRedirectEndpoint) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
